import { z } from 'zod'

import { storeSchema } from './stores'

const bankAccountShortModelSchema = z.object({
  id: z.string(),
  iban: z.string(),
  isMain: z.boolean(),
})

export const organisationDtoSchema = z.object({
  id: z.string(),
  code: z.number(),
  description: z.string(),
  vatNumber: z.string(),
  fullLegalName: z.string(),
  shortLegalName: z.string(),
  legalAddress: z.string(),
  postalAddress: z.string(),
  registrationDate: z.union([z.string(), z.number()]),
  mainBankAccount: z.string().nullable().optional(),
  mainBankAccountShortModel: bankAccountShortModelSchema.nullable().optional(),
  phoneNumber: z.string(),
  email: z.string(),
  signatoryFullName: z.string(),
  signatoryPosition: z.string(),
  signatoryOperatesUnder: z.string(),
  contactPhone: z.string(),
  emailDistribution: z.string(),
  ipRegistrationDate: z.union([z.string(), z.number()]),
  isLegal: z.boolean(),
  supervisorManagerShortModel: z
    .object({
      id: z.string(),
      code: z.number(),
      description: z.string(),
      name: z.string(),
      phoneNumber: z.string(),
      login: z.string(),
      telegramActivated: z.boolean().optional().default(false),
    })
    .nullable(),
  roles: z.array(
    z.enum([
      'OWNER_ORGANISATION',
      'CLIENT_ORGANISATION',
      'PARTNER_ORGANISATION',
      'PRODUCT_SUPPLIER_ORGANISATION',
      'NO_DB_SUPPLIER',
    ])
  ),
})

export const organisationSchema = z.object({
  organisationDto: organisationDtoSchema,
  segmentDto: z
    .object({
      id: z.string(),
      code: z.number(),
      description: z.string(),
      owner: z.string(),
      isForClient: z.boolean(),
      isActive: z.boolean(),
    })
    .nullable(),
  storesDto: z.array(storeSchema),
  deliveryAddressesDto: z.array(
    z.object({
      id: z.string(),
      organisation: z.string(),
      address: z.string(),
    })
  ),
  bankAccountsDto: z.array(
    z.object({
      id: z.string(),
      organisationShortModel: z
        .object({
          id: z.string(),
          code: z.number(),
          description: z.string(),
          fullLegalName: z.string(),
          shortLegalName: z.string(),
          isLegal: z.boolean(),
        })
        .nullable(),
      iban: z.string(),
      currencyModel: z
        .object({
          id: z.string(),
          code: z.number(),
          description: z.string(),
          fullName: z.string(),
          synonyms: z.string(),
        })
        .nullable(),
      bankDto: z
        .object({
          id: z.string(),
          code: z.string(),
          description: z.string(),
        })
        .nullable(),
      isMain: z.boolean(),
    })
  ),
  contactInfosDto: z.array(
    z.object({
      id: z.string(),
      organisation: z.string(),
      type: z.enum(['EMAIL', 'ADDRESS', 'PHONE', 'FAX']),
      description: z.string(),
    })
  ),
  contractsDto: z.array(
    z.object({
      id: z.string(),
      ownerShortModel: z
        .object({
          id: z.string(),
          code: z.number(),
          description: z.string(),
          fullLegalName: z.string(),
          shortLegalName: z.string(),
          isLegal: z.boolean(),
        })
        .nullable(),
      code: z.number(),
      description: z.string(),
      creationDate: z.union([z.string(), z.number()]),
      number: z.string(),
      clientShortModel: z
        .object({
          id: z.string(),
          code: z.number(),
          description: z.string(),
          fullLegalName: z.string(),
          shortLegalName: z.string(),
          isLegal: z.boolean(),
        })
        .nullable(),
      currencyModel: z
        .object({
          id: z.string(),
          code: z.number(),
          description: z.string(),
          fullName: z.string(),
          synonyms: z.string(),
        })
        .nullable(),
      isActive: z.boolean(),
      isSingle: z.boolean(),
      singleOrder: z.string(),
      paymentTypeModel: z
        .object({
          id: z.string(),
          enumOrder: z.number(),
          paymentType: z.enum(['CASH', 'NON_CASH']),
        })
        .nullable(),
    })
  ),
})
